/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

/**
 * Imports the Freighthub API.
 */
import { api } from '../api';

export default {
    /**
     * GET
     */
    index: function() {
        return api.get( '/carrier/gps/journey-requests-truck');
    },

    /**
     * POST
     */
    store: function( { truckPlate, startTime, endTime } ){
        return api.post( '/carrier/gps/journey-requests-truck',
            {
                truck_plate: truckPlate,
                start_time: startTime,
                end_time: endTime,
            }
        );
    },

    /**
     * POST
     */
    show: function( id ){
        return api.get( `/carrier/gps/journey-requests-truck/${id}`);
    },

    /**
     * DELETE
     */
    delete: function( id ){
        return api.delete( `/carrier/gps/journey-requests-truck/${id}`);
    },
}